import { FormRow, RichTextArea } from '~/components';

type Term = {
  label: string;
  value: string | number | null | undefined;
  newValueField: React.ReactNode;
  prevValueName?: string;
  prefix?: string;
  prevValueIsHtml?: boolean;
};

export interface TermCompareSectionProps {
  terms: Term[];
  title: string;
  changedTermsCount: number;
  icon?: React.ReactNode;
  description?: string;
  classname?: string;
}
const Tag = ({ label }: { label: string }) => {
  return (
    <span className="inline-flex rounded-full bg-warning-500 px-3 py-1 text-sm font-medium text-white">
      {label}
    </span>
  );
};

export const TermCompareSection = (props: TermCompareSectionProps) => {
  const { terms, title, description, icon, classname, changedTermsCount } = props;

  return (
    <div className={`h-full flex flex-col ${classname ?? ''}`}>
      <div className="flex items-center gap-2 w-full p-4 bg-grey-950 border border-grey-900 rounded-t-lg">
        {icon}
        {title}
        <Tag label={`${changedTermsCount} ${changedTermsCount === 1 ? 'change' : 'changes'}`} />
      </div>
      <div className="bg-white border border-grey-900 rounded-b-lg flex-1 p-4">
        <p className="body-text text-left mb-4">{description}</p>
        <div className="grid grid-cols-2 gap-4 text-left border-b border-grey-800 pb-2 mb-2">
          <div className="col-span-1">
            <p className="text-sm font-bold text-grey-400">Previous Terms</p>
          </div>
          <div className="col-span-1 flex justify-end">
            <p className="text-sm font-bold text-warning-950">Your Proposed Terms</p>
          </div>
        </div>
        <div className="mt-2">
          {terms.map((term) => (
            <div
              key={`${title}-${term.label}`}
              className="grid grid-cols-2 gap-4 items-center border-b border-grey-800 py-3"
            >
              {term.prevValueIsHtml ? (
                <>
                  <p className="mr-4 text-grey-400 text-left col-span-2">{term.label}:</p>
                  <FormRow>
                    <RichTextArea name={term.prevValueName || term.label} disabled />
                  </FormRow>
                </>
              ) : (
                <div className="flex items-center">
                  <p className="mr-4 text-grey-400">{term.label}:</p>
                  <p className="whitespace-pre-line text-left font-bold text-grey-400">
                    {term.prefix ? term.prefix : ''}
                    {term.value || term.value === 0 ? term.value : '---'}
                  </p>
                </div>
              )}
              <div className="flex items-center justify-end">
                <FormRow className="w-fit text-left">{term.newValueField}</FormRow>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
